import React from 'react';
import PageLayout from '../components/PageLayout';
import Community from '../components/Community';
import usePageMeta from '../hooks/usePageMeta';

export default function CommunityPage() {
  usePageMeta(
    'Community & Local Initiatives | Hotel Respiro',
    'Hotel Respiro supports local farming in Santo Antão, ocean initiatives and cabo-verdean arts and crafts in São Vicente.'
  );

  return (
    <PageLayout>
      <div data-testid="community-page">
        <Community />
      </div>
    </PageLayout>
  );
}
